import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_dashboard/")({
  beforeLoad: () => {
    throw redirect({ to: "/claims" });
  },
});
